import React, { useState, useEffect } from 'react';
import { FileUploadState } from './DirectFileUploader';
import './file-preview.scss';
import { ReactComponent as LoadingIcon } from '../../../icons/loading-rings.svg';
import { ReactComponent as CloseIcon } from '../../../icons/close.svg';

interface FilePreviewProps {
  files: FileUploadState[];
  onRemoveFile: (fileId: string) => void;
}

// Helper function to check if a file is an image
const isImageFile = (fileType: string): boolean => {
  return fileType.startsWith('image/');
};

export const FilePreview: React.FC<FilePreviewProps> = ({
  files,
  onRemoveFile,
}) => {
  if (files.length === 0) return null;

  return (
    <div className='file-preview'>
      {files.map((file) => {
        const isImage = isImageFile(file.type);
        const hasPreview = isImage && file.previewUrl;

        return (
          <div
            key={file.id}
            className={`file-preview-item ${file.status === 'error' ? 'error' : ''} ${isImage ? 'image-preview' : ''}`}
          >
            {isImage && (
              <div className='thumbnail-container'>
                {hasPreview && (
                  <img
                    src={file.previewUrl}
                    alt={file.name}
                    className='file-thumbnail'
                  />
                )}
                {file.status === 'uploading' && (
                  <div className='file-loading'>
                    <LoadingIcon width={16} height={16} />
                  </div>
                )}
              </div>
            )}
            {!isImage && file.status === 'uploading' && (
              <div className='file-loading non-image'>
                <LoadingIcon width={16} height={16} />
              </div>
            )}
            <div className='file-info'>
              {(!isImage || file.status === 'error') && (
                <span className='file-name'>{file.name}</span>
              )}

              {file.status === 'error' && (
                <span className='file-error'>
                  {file.error || 'Upload failed'}
                </span>
              )}
              {file.status !== 'error' && !isImage && (
                <span className='file-ext'>
                  {file.name.split('.').pop()?.toUpperCase()} File
                </span>
              )}
            </div>
            <div
              className='remove-file'
              onClick={() => onRemoveFile(file.id)}
              aria-label='Remove file'
              role='button'
            >
              <CloseIcon />
            </div>
          </div>
        );
      })}
    </div>
  );
};
